import type { ArdoqId } from '@ardoq/api-types';
import type { FieldValueScopeSource } from '@ardoq/data-model';
import type { ReferenceFilterContext } from '@ardoq/filter-helpers';
import { referenceInterface } from '../referenceInterface';

/**
 * Id-based wrapper around `referenceInterface.isIncludedInContextByFilter`.
 * Missing references are treated as included — matches the pre-migration
 * behavior of the front-end implementation, which defaulted to `true` when
 * the reference was not in the store.
 */
export const isReferenceIdIncludedInContextByFilter = (
  referenceId: ArdoqId,
  ctx?: ReferenceFilterContext,
  scopeSource?: FieldValueScopeSource | null
): boolean => {
  const reference = referenceInterface.get(referenceId);
  return reference
    ? referenceInterface.isIncludedInContextByFilter(
        reference,
        ctx,
        scopeSource
      )
    : true;
};
